const createCarouselImages = ({ selectedAssetType, interiorImages, selectedAssetCategory, exteriorImages }) => {
  const carouselImages =
    selectedAssetType === 'interior'
      ? interiorImages?.[selectedAssetCategory]
      : exteriorImages?.[selectedAssetCategory];

  const missingAssetPlaceholderImage = exteriorImages && exteriorImages?.studio ? exteriorImages?.studio[0] : null;

  const hasImages = carouselImages && carouselImages.length > 0;

  return { carouselImages, hasImages, missingAssetPlaceholderImage };
};

export default createCarouselImages;
